import axios from 'axios'
import {API_URL, LOGIN_API_URL} from "./URL";

let interceptor = null;

export const setDefaultHeaderToken = (token) => {
    interceptor = axios.interceptors.request.use(function (config) {
        if (config.url.startsWith(API_URL) && !config.url.includes(LOGIN_API_URL)) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    })

}

export const cleanHeaderToken = () => {
    if (interceptor != null)
        axios.interceptors.request.eject(interceptor)
}

export const setDefaultContentType = (contentType) => {
    axios.defaults.headers['Content-Type'] = contentType
}

export const configAxiosDefault = () => {
    setDefaultContentType('application/json')
}

